import { Button, Modal, ModalBody, ModalHeader } from 'react-bootstrap';
import { useContext } from 'react';
import {
  MarketSignalContext,
  MarketSignalContextType,
} from '@/modules/market-signals/contexts/market-signal-context';
import { MarketSignalEntryHeader } from '@/modules/market-signals/components/market-signals/scroller/market-signal-scroller-entry';

export default function MarketSignalModal() {
  const { selectedItem, setSelectedItem } =
    useContext<MarketSignalContextType>(MarketSignalContext);

  return (
    <Modal
      show={!!selectedItem}
      onHide={() => setSelectedItem(undefined)}
      onBackdropClick={e => setSelectedItem(undefined)}
    >
      <ModalHeader>
        <div className={'w-100 '}>
          <div className={'small'}>
            {selectedItem && <MarketSignalEntryHeader signal={selectedItem} />}

            <div className={'d-flex justify-content-between align-items-baseline'}>
              <h3>{selectedItem?.headline}</h3>
              <Button variant={'warning'} onClick={() => setSelectedItem(undefined)}>
                Close
              </Button>
            </div>
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <div dangerouslySetInnerHTML={{ __html: selectedItem?.body || '' }} />
      </ModalBody>
    </Modal>
  );
}
